import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Impact2 from "./Impact2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import syep2024 from "../../Assets/syepMain.png";

import syep2 from "../../Assets/syep_2025_2.jpg";
import syep2025 from "../../Assets/syep_2025.jpeg";
import gradSYEP2024 from "../../Assets/gradSYEP.png";
import gradSYEP2025 from "../../Assets/SYEP_2025_Grad.png";
import syep3 from "../../Assets/syep_2025_3.jpg";

import syepCareer1 from "../../Assets/syep-career-1.png";
import syepCareer2 from "../../Assets/syep-career-2.png";
import syepCareer3 from "../../Assets/syep-career-3.png";
import syepCareer4 from "../../Assets/syep-career-4.png";



// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";
import { useTranslation } from "react-i18next";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  syep2,
  syep3,
  syep2024,
  gradSYEP2024,
  syep2025,
  gradSYEP2025,
  syepCareer1,
  syepCareer2,
  syepCareer3,
  syepCareer4,
];


function Impact() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const navigate = useNavigate(); // Initialize navigate
    
  
  const handleClick = () => {
    navigate("/registration#internship-section"); // This will navigate to the "/another-page" route
  };

  


  // Settings for the Slick slider
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2400, // Time between slides in ms
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  const sliderAltsRaw = t("programs.internship.sliderAlts", { returnObjects: true });
  const sliderAlts = Array.isArray(sliderAltsRaw) ? sliderAltsRaw : [];


  return (
    <Container fluid className="about-section impact-page">
      <Particle />
      <Container className="impact-container">
        <header className="impact-hero">
          <h1 className="impact-hero-title">
            {t("programs.internship.hero.titlePrefix")} <strong className="purple">{t("programs.internship.hero.titleEmphasis")}</strong>
          </h1>
          <p className="impact-hero-lead">
            {t("programs.internship.hero.lead")}
          </p>
          <div className="impact-hero-cta">
            <Button onClick={handleClick} className="custom-yellow-btn impact-apply-btn">
              {t("common.applyNow")}
            </Button>
          </div>
        </header>

        <Row className="impact-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="impact-left">
            <div className="policy-card ambassadors-slider-card" aria-label={t("programs.internship.aria.highlights")}> 
              <Slider {...settings}>
                {sliderImages.map((imageSrc, index) => (
                  <div key={index} className="ambassadors-slide">
                    <SlickLazyImage
                      src={imageSrc}
                      alt={sliderAlts[index] || t("programs.internship.sliderAltFallback")}
                      className="ambassadors-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>

          <Col md={5} className="impact-right">
            <div className="policy-card impact-summary-card">
              <h2 className="impact-card-title">{t("programs.internship.summary.title")}</h2>
              <p className="about-text impact-card-text">
                {t("programs.internship.summary.text")}
              </p>
              <ul className="impact-bullets">
                {t("programs.internship.summary.bullets", { returnObjects: true }).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <Button onClick={handleClick} className="custom-yellow-btn impact-apply-btn impact-apply-btn-secondary">
                {t("common.applyHere")}
              </Button>
            </div>
          </Col>
        </Row>

        <Impact2 onApply={handleClick} />

        <section className="impact-testimonials-section" aria-label={t("common.testimonials")}>
          <h2 className="impact-section-heading">{t("common.testimonials")}</h2>
          <div className="impact-testimonials">
            <Testimonials reviews={reviews} />
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default Impact;
